module.exports = __webpack_public_path__ + "static/0001-cdd1f7254e062292ac42f331883a4571.jpg";